import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { observeResource } from "kea-resource";
import { componentToRx } from "app/main/std";

export interface Props {
    cliente: models.ClienteCreditoDto;
    totalAPagar: number;
}

interface ViewProps {
    nombreCliente: string;
    limiteCredito: number | null;
    creditoRestante: number | null;
    creditoBloqueado: boolean | null;
    saldo: number;
    totalAPagar: number;
}

class ACreditoView extends React.PureComponent<ViewProps> {
    render() {
        const saldoPago = this.props.saldo + this.props.totalAPagar;
        const superaLimite = saldoPago > (this.props.limiteCredito || 0);
        const creditoBloqueado = this.props.creditoBloqueado;
        return (
            <div>
                <label>Nombre del cliente:</label> {this.props.nombreCliente}
                <br />
                <label>Limite de crédito:</label> {kea.formatCurrency(this.props.limiteCredito || 0)}
                <br />
                <label>Crédito restante:</label> {kea.formatCurrency(this.props.creditoRestante)}
                <br />
                <label>Saldo:</label> {kea.formatCurrency(this.props.saldo)}
                <br />
                <h3>
                    {
                        creditoBloqueado &&
                        <span className="label label-danger">
                            Linea de crédito bloqueada
                        </span>
                    }
                    <br />
                    <span className={"label label-" + ((superaLimite || creditoBloqueado) ? "danger" : "success")}>
                        Saldo después del pago: {kea.formatCurrency(saldoPago)}
                    </span>
                </h3>
            </div>
        )
    }
}

const ACreditoViewRx = componentToRx(ACreditoView);

export class ACredito extends React.PureComponent<Props> {
    cliente = (props: Props) => props.cliente;

    limiteCredito = createSelectorRx(this.cliente, cliente => cliente.LimiteCredito);
    saldo = createSelectorRx(this.cliente, cliente => cliente.SaldoCredito);
    nombreCliente = createSelectorRx(this.cliente, cliente => cliente.Nombre);
    creditoBloqueado = createSelectorRx(this.cliente, cliente => cliente.CreditoBloqueado);
    render() {
        const nombreCliente = this.nombreCliente(this.props);
        const limiteCredito = this.limiteCredito(this.props);
        const saldo = this.saldo(this.props);
        const creditoBloqueado = this.creditoBloqueado(this.props);

        return <ACreditoViewRx nombreCliente={nombreCliente} creditoBloqueado={creditoBloqueado} creditoRestante={null} limiteCredito={limiteCredito} saldo={saldo} totalAPagar={this.props.totalAPagar} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/pago/views/creditocomp.tsx